import $ from 'jquery';
import React from 'react';
import { string, shape, arrayOf, func, bool } from 'prop-types';

export default class DropdownFilter extends React.Component {
    constructor(props) {
        super(props);

        this.handleTitleClick = this.handleTitleClick.bind(this);
    }

    // @NOTE - right now only the multi checkbox requires the isFocused state,
    // if in the future this is required by other filters also then we should push this function up a level to Filters
    // go a step further and make all filter components call the toggleFocus function when they are in focus
    componentDidMount() {
        $('body').click(e => {
            if (this.props.isFocused) {
                const clickedOn = $(e.target);
                const rootClass = '.dropdown-filter';
                if (!clickedOn.hasClass(rootClass) && !clickedOn.parents(rootClass).length) {
                    this.props.toggleFocus.call(this, null, null);
                }
            }
        });
    }

    handleTitleClick() {
        if (this.props.isFocused) {
            this.props.toggleFocus.call(this, null);
        } else {
            this.props.toggleFocus.call(this, this.props.filter);
        }
    }

    render() {
        const listId = `dropdown-${this.props.filter.code}`;
        return (
            <div className={`dropdown-wrapper dropdown-filter ${this.props.isFocused ? 'is-open' : ''} ${this.props.classModifier}`}>
                <div className="fl-filter-label">{this.props.filter.label}</div>
                <div className="select-wrapper">
                    <div className="input-wrapper">
                        <div
                            className="select"
                            onClick={this.handleTitleClick}
                            onKeyPress={this.handleTitleClick}
                            role="combobox"
                            aria-controls={listId}
                            aria-expanded={this.props.isFocused ? 'true' : 'false'}
                            tabIndex="0"
                        >
                            <p className="dropdown-filter-title-text">{this.props.selectedItems.length ? this.props.selectedItems[0] : `All ${this.props.filter.label}`}</p>
                        </div>
                    </div>
                </div>
                <div className="dropdown-filter-panel" id={listId}>
                    <div className="dropdown-filter-panel-inner">
                        <div
                            key="any"
                            onClick={e => { this.props.toggleFilters(e, this.props.filter, ''); this.props.toggleFocus.call(this, null); }}
                            onKeyPress={e => { this.props.toggleFilters(e, this.props.filter, ''); this.props.toggleFocus.call(this, null); }}
                            role="checkbox"
                            aria-checked={this.props.selectedItems.length ? 'false' : 'true'}
                            tabIndex="0"
                            className={`dropdown-filter-item ${this.props.selectedItems.length ? '' : 'active'}`}
                        >
                            <span>All {this.props.filter.label}</span>
                        </div>
                        {this.props.filter.values.map(value => (
                            <div
                                key={value}
                                onClick={e => {
                                    this.props.toggleFilters(e, this.props.filter, value);
                                    this.props.toggleFocus.call(this, null);
                                }}
                                onKeyPress={e => {
                                    this.props.toggleFilters(e, this.props.filter, value);
                                    this.props.toggleFocus.call(this, null);
                                }}
                                role="checkbox"
                                aria-checked={this.props.selectedItems.indexOf(value) !== -1 ? 'true' : 'false'}
                                tabIndex="0"
                                className={`dropdown-filter-item ${this.props.selectedItems.indexOf(value) !== -1 ? 'active' : ''}`}
                            >
                                <span>{value}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

DropdownFilter.propTypes = {
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(string).isRequired
    }).isRequired,
    classModifier: string,
    selectedItems: arrayOf(string).isRequired,
    toggleFilters: func.isRequired,
    isFocused: bool.isRequired,
    toggleFocus: func.isRequired
};

DropdownFilter.defaultProps = { classModifier: '' };
